import React, { createContext, useCallback, useContext, useState } from "react";

const PatientDetailsContext = createContext();

export const usePatientDetails = () => {
  const context = useContext(PatientDetailsContext);
  if (!context) {
    throw new Error(
      "usePatientDetails must be used within a PatientDetailsProvider"
    );
  }
  return context;
};

export const PatientDetailsProvider = ({ children }) => {
  const [patientDetails, setPatientDetails] = useState({
    patientId: "",
    patientName: "",
    accessionNo: "",
    dateOfBirth: "",
    modalityCode: "",
    patientSex: "",
    insuranceName: "",
    insuranceNumber: "",
    weight: "",
  });

  const [isEditing, setIsEditing] = useState(false);
  const [isSaving, setIsSaving] = useState(false);

  const updatePatientDetails = useCallback((field, value) => {
    setPatientDetails((prev) => ({ ...prev, [field]: value }));
    setIsEditing(true);
  }, []);

  const resetPatientDetails = useCallback(() => {
    setPatientDetails({
      patientId: "",
      patientName: "",
      accessionNo: "",
      dateOfBirth: "",
      modalityCode: "",
      patientSex: "",
      insuranceName: "",
      insuranceNumber: "",
      weight: "",
    });
    setIsEditing(false);
  }, []);

  const setAllPatientDetails = useCallback((details) => {
    setPatientDetails(details);
    setIsEditing(false);
  }, []);

  const value = {
    patientDetails,
    isEditing,
    isSaving,
    updatePatientDetails,
    resetPatientDetails,
    setAllPatientDetails,
    setIsEditing,
    setIsSaving,
  };

  return (
    <PatientDetailsContext.Provider value={value}>
      {children}
    </PatientDetailsContext.Provider>
  );
};
